import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NewNotificationForm } from "../../components/notifications/forms/NewNotificationForm";
import {
  fetchDistributors,
  selectAllDistributors,
} from "../../common/features/distributors/distributorsSlice";
import CircularProgress from "@mui/material/CircularProgress";

import Helmet from "react-helmet";

export default function NewNotification() {
  const dispatch = useDispatch();
  // Get user role from Redux
  const { role } = useSelector((state) => state.auth.user);

  //Load distributors Redux
  const distributors = useSelector(selectAllDistributors);
  const distributorStatus = useSelector((state) => state.distributors.status);

  useEffect(() => {
    if (distributorStatus === "idle") {
      dispatch(fetchDistributors(role));
    }
  }, [distributorStatus, dispatch]);

  if (!Array.isArray(distributors) || distributors.length === 0) {
    return <CircularProgress size={24} color="secondary"></CircularProgress>;
  } else {
    <div>Error</div>;
  }
  return (
    <>
      <h3>Nueva Notificatión</h3>
      <Helmet>
        <title>Nueva Notificatión - Marina BCN</title>
      </Helmet>
      <NewNotificationForm distributors={distributors} />
    </>
  );
}
